import React from "react"
import { getOrdinal } from "../../utils/get-ordinal"
import { SvgPiechartOneQuarter } from "../icons"

interface Props {
  serviceValues: any
  serviceType: any
}
const FlexPaymentDetails: React.FC<Props> = ({
  serviceValues,
  serviceType,
}) => {
  const isBundle = serviceType === "bundle"

  const billingSource = isBundle
    ? serviceValues?.package
    : serviceValues?.billing

  const installmentIncrements = billingSource?.installmentIncrements || []

  const totalAmount = isBundle
    ? serviceValues?.package?.packageCost
    : serviceValues?.sessionCost

  const getFirstInstallmentAmount = () => {
    const upFrontPercentage = billingSource?.upFrontPercentage / 100
    return ((totalAmount || 0) * upFrontPercentage).toFixed(2)
  }

  const getSubsequentInstallmentAmount = () => {
    const firstInstallmentAmount = parseFloat(getFirstInstallmentAmount())
    const numberInstallments = billingSource?.installmentIncrements?.length || 0

    if (!numberInstallments) return "0.00"

    const remainingAmount =
      parseFloat(totalAmount || 0) -
      parseFloat(firstInstallmentAmount.toFixed(2))

    return (remainingAmount / numberInstallments).toFixed(2)
  }

  const decodeUnicodeSymbol = (unicodeStr: string | undefined | null) => {
    if (!unicodeStr) {
      return ""
    }
    return unicodeStr.replace(/\\u([\dA-F]{4})/gi, (match, grp) => {
      return String.fromCharCode(parseInt(grp, 16))
    })
  }

  return (
    <>
      <div className="">
        <h4 className="font-bold text-base mb-[8px]">Preview</h4>
        <div className="w-full border rounded-xl p-[20px] flex flex-col">
          <p className="text-graySlate text-base mb-[32px]">
            Payment Schedule
          </p>
          {serviceValues.payment_term !== "installment" && (
            <>
              <div className="flex flex-col sm:flex-row sm:items-center w-full gap-2 mb-[16px] min-w-0">
                <div className="flex items-center gap-[16px] min-w-0">
                  <div className="w-[24px] h-[24px] bg-blurple rounded-full text-white font-bold justify-center items-center flex shrink-0">
                    {decodeUnicodeSymbol(serviceValues.symbol)}
                  </div>
                  <p className="text-[16px] break-words sm:whitespace-nowrap">
                    Payment at checkout
                  </p>
                </div>

                <div className="hidden sm:block mx-[12px] w-full border-b border-grayCloud border-dashed"></div>

                <span className="text-base">
                  {decodeUnicodeSymbol(serviceValues.symbol)}
                  {serviceType === "consultation" &&
                  serviceValues?.consultation?.isFree
                    ? 0.0
                    : serviceType === "bundle"
                    ? serviceValues?.package.packageCost
                    : isNaN(serviceValues?.sessionCost)
                    ? "0.00"
                    : serviceValues?.sessionCost.toFixed(2)}
                </span>
              </div>

              <div className="text-graySlate w-full bg-grayMist rounded-lg p-[26px] flex items-center justify-center text-base">
                <p className="text-center">
                  Payment will be charged{" "}
                  <strong className="text-black">immediately</strong> at
                  checkout.
                </p>
              </div>
              <div className="flex items-center w-full my-[32px]">
                <div className="flex-grow h-px bg-grayMist"></div>
                <span className="px-4 text-graySlate text-sm font-medium">
                  OR
                </span>
                <div className="flex-grow h-px bg-grayMist"></div>
              </div>
            </>
          )}
          <div className="flex w-full items-center justify-between mb-[16px]">
            <div className="flex items-center gap-[16px] min-w-0">
              <SvgPiechartOneQuarter />
              <p className="text-[16px] break-words sm:whitespace-nowrap">
                Payment at booking
              </p>
            </div>
            <div className="mx-0 sm:mx-[12px] w-full border-b border-grayCloud border-dashed" />{" "}
            <span className="text-base">
              {decodeUnicodeSymbol(serviceValues.symbol)}

              {getFirstInstallmentAmount()}
            </span>
          </div>
          {installmentIncrements.length > 0 &&
            installmentIncrements.map((installment: any, index: number) => (
              <div className="grid grid-cols-1 sm:grid-cols-[auto_1fr_auto] items-center gap-3 w-full min-w-0 mb-[16px]">
                <div className="flex items-center gap-[16px] min-w-0">
                  <SvgPiechartOneQuarter />
                  <p className="text-[16px] break-words sm:whitespace-nowrap">
                    {getOrdinal(index + 1)} installment {installment.time}{" "}
                    {installment.time > 1
                      ? installment.type
                      : installment.type.replace(/s$/, "")}{" "}
                    later
                  </p>
                </div>

                <div className="hidden sm:block mx-[12px] w-full border-b border-grayCloud border-dashed" />

                <span className="text-base font-medium whitespace-nowrap">
                  {decodeUnicodeSymbol(serviceValues.symbol)}
                  {getSubsequentInstallmentAmount()}
                </span>
              </div>
            ))}
          <div className="text-graySlate w-full bg-grayMist rounded-lg p-[26px] flex items-center justify-center text-base">
            <p className="text-center">
              Future payments will be charged automatically based on this
              schedule, starting from the date the client completes their
              purchase.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default FlexPaymentDetails
